import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

export const FILING_DETAILS_MODAL = 'FILING_DETAILS_MODAL';

import type { FilingDetailsModalProps } from './types';

export const filingDetailsModalAction = createAction(
  rootUiActions.createDialog.toString(),
  (props: FilingDetailsModalProps) =>
    rootUiTypes.mkRootUiData({
      type: FILING_DETAILS_MODAL,
      props: ImmutableMap({
        ...props,
        title: props?.title || 'Personal Income & Tax Profile',
        modalType: props?.modalType || 'drawer',
      }),
    }),
);

export const dispatchFilingDetailsModal = (props: FilingDetailsModalProps) =>
  store?.dispatch(filingDetailsModalAction(props));
export default dispatchFilingDetailsModal;
